export default __webpack_public_path__ + "static/media/pgmico(21).9329ed87.png";